"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
// MUI
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const CompareArrows_1 = __importDefault(require("@mui/icons-material/CompareArrows"));
const RadioButtonUnchecked_1 = __importDefault(require("@mui/icons-material/RadioButtonUnchecked"));
const CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
const Circle_1 = __importDefault(require("@mui/icons-material/Circle"));
const GetApp_1 = __importDefault(require("@mui/icons-material/GetApp"));
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
// Data
const utils_1 = require("data/transactions/utils");
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const RegMEditBar = ({ selectedTxns, onEdit, onDelete, onMatch, onReviewed, onNotReviewed, onDownload, showReviewOptions = true, isWindowsDataset, }) => {
    // SELECTORS ========================================================================
    const { classes } = useStyles();
    const showReview = (0, react_redux_1.useSelector)(selectors_1.showReviewed);
    const { getSharedCurrency, formatAmount } = (0, useQCurrency_1.default)();
    const getTxnInfo = () => {
        let total = 0;
        let hasRecurring = false;
        selectedTxns === null || selectedTxns === void 0 ? void 0 : selectedTxns.forEach((item) => {
            total += Number(item.amount);
            hasRecurring = hasRecurring || (0, utils_1.isUnacceptedScheduledTxn)(item);
        });
        return { total, hasRecurring };
    };
    const matchAvailable = () => {
        if ((selectedTxns === null || selectedTxns === void 0 ? void 0 : selectedTxns.size) !== 2) {
            return false;
        }
        const txns = selectedTxns.toArray();
        return (0, utils_1.areMatchable)(txns[0], txns[1]);
    };
    const numSelected = selectedTxns === null || selectedTxns === void 0 ? void 0 : selectedTxns.size;
    const showMatch = matchAvailable();
    const txnInfo = getTxnInfo();
    const currSymbol = getSharedCurrency([selectedTxns]);
    const totalText = formatAmount(txnInfo.total, currSymbol);
    const selText = `${numSelected} Transaction${numSelected > 1 ? 's' : ''} Selected  (${totalText})`;
    const unreviewedTxnsSelected = selectedTxns === null || selectedTxns === void 0 ? void 0 : selectedTxns.some((txn) => !txn.isReviewed);
    return (<div className={classes.container}>
      <div className={classes.iconContainer}>
        {showMatch && (<QIconButton_1.default aria-label="Match transactions" id="bulk-edit-ui-match" IconComponent={CompareArrows_1.default} onClick={onMatch} tooltip={'Match the downloaded transaction to the manual transaction'} size="small-target"/>)}

        {!txnInfo.hasRecurring && (<QIconButton_1.default aria-label="Edit selected transactions" id="bulk-edit-ui-edit" IconComponent={Edit_1.default} onClick={onEdit} tooltip="Bulk edit all selected transactions at once" size="small-target"/>)}

        <QIconButton_1.default aria-label="Delete selected transactions" id="bulk-edit-ui-delete" IconComponent={Delete_1.default} onClick={onDelete} tooltip="Delete all selected transactions" size="small-target"/>

        {!txnInfo.hasRecurring && showReview && (<>
            {showReviewOptions && (unreviewedTxnsSelected || !isWindowsDataset) && <QIconButton_1.default aria-label="Mark selected transactions as reviewed" id="bulk-edit-ui-mark-as-reviewed" IconComponent={isWindowsDataset ? CheckCircleOutline_1.default : RadioButtonUnchecked_1.default} IconProps={{
                    className: (0, classnames_1.default)(classes.reviewed, isWindowsDataset ? 'qwinReviewed' : 'reviewed'),
                }} onClick={onReviewed} tooltip="Mark all selected transactions reviewed" size="small-target"/>}
            {!isWindowsDataset && <QIconButton_1.default aria-label="Mark all selected transactions as not reviewed" id="bulk-edit-ui-mark-as-not-reviewed" IconComponent={Circle_1.default} IconProps={{ className: (0, classnames_1.default)(classes.reviewed, 'notReviewed') }} onClick={onNotReviewed} tooltip="Mark all selected transactions as not reviewed" size="small-target"/>}
          </>)}

        <QIconButton_1.default aria-label="Download a CSV file with all selected transactions" id="bulk-edit-ui-mark-as-reviewed" IconComponent={GetApp_1.default} onClick={onDownload} tooltip="Download a CSV file with all selected transactions" size="small-target"/>
      </div>
      <Typography_1.default variant="subtitle1" className={classes.text} id="reg-header-selected-total">
        {selText}
      </Typography_1.default>
    </div>);
};
exports.default = RegMEditBar;
